import {
  CreateReviewTag,
  UpdateReviewTag,
  DeleteReviewTag,
} from '@/graphql';
import { apolloClient } from '@/plugins/apollo';

const actions = {
  async createReviewTag(context, { reviewId, label }) {
    const response = await apolloClient.mutate({
      mutation: CreateReviewTag,
      variables: {
        tag: {
          review: reviewId,
          label: label,
        },
      },
      refetchQueries: [
        'GetReviewForSettingsPage',
        'GetFullTextReviewConflictsPage',
      ],
      awaitRefetchQueries: true,
    });

    return response.data.createTag;
  },
  async updateReviewTag(context, tag) {
    const response = await apolloClient.mutate({
      mutation: UpdateReviewTag,
      variables: {
        tag: {
          id: tag.id,
          label: tag.label,
        },
      },
      refetchQueries: ['GetReviewForSettingsPage'],
      awaitRefetchQueries: true,
    });

    return response.data.updateTag;
  },
  async deleteReviewTag(context, tagId) {
    const response = await apolloClient.mutate({
      mutation: DeleteReviewTag,
      variables: { id: tagId },
      refetchQueries: [
        'GetReviewForSettingsPage',
        'GetFullTextReviewConflictsPage',
        'GetReference',
        'GetReferencesByReviewIdAndFilters',
        'SearchReferences',
        'GetReferencesByTagId',
      ],
      awaitRefetchQueries: true,
    });

    return response.data.deleteTag;
  },
};

const state = {};

const mutations = {};

export default {
  namespaced: true,
  actions,
  state,
  mutations,
};
